import { Store } from "pullstate";

interface IUIStore {
  drawerIsOpen: boolean;
}

export const UIStore = new Store<IUIStore>({
  drawerIsOpen: false,
});
